import { fetchFromServer, syncDependency, type DependencySyncConfig } from "./dependency-sync";
import { categories } from "@/plugins/LocalForagePlugin";
import { categoriesSyncKey } from "@/types/products/product-keys";
import type { ApiFetchResponse } from "@tmi/types/api/fetch";
import type { Categories } from "@tmi/types/api/content-models";
import type { Category } from "@tmi/types/entities";

const config: DependencySyncConfig<Categories, Category, Category> = {
    name: 'category',
    store: categories,
    syncKey: categoriesSyncKey,
    throttle: { hours: 4 },
    queryId: '1406515c5acd2606068ab34969384860',
    pageSize: 500,
    extractPayload: ( response: ApiFetchResponse<Categories> ) => response?.data?.categoryCatalog?.categories,
    mapItem: ( c: Category ): Category => ( {
        id: c.id,
        name: c.name,
        slug: c.slug
    } )
};

export async function refreshCategoriesFromServer(): Promise<Category[]> {
    return fetchFromServer( config );
}

export async function loadCategoryMap( categoriesMap: Map<string, Category> ): Promise<boolean> {
    return syncDependency( config, categoriesMap );
}
